// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__27yNI","detailsBorder":"styles_detailsBorder__3m121"};